import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';

export interface ILogger {
  debug(message?: any, ...optionalParams: any[]): void;
  info(message?: any, ...optionalParams: any[]): void;
  log(message?: any, ...optionalParams: any[]): void;
  warn(message?: any, ...optionalParams: any[]): void;
  error(message?: any, ...optionalParams: any[]): void;
}

export const LogHandler = new InjectionToken<ILogger>('Customer apps log handler');

@Injectable({
  providedIn: 'root',
})
export class LoggerService implements ILogger {
  constructor(@Optional() @Inject(LogHandler) private logHandler?) {}

  debug(message?: any, ...optionalParams: any[]): void {
    this.logHandler?.debug(message, ...optionalParams);
  }

  info(message?: any, ...optionalParams: any[]): void {
    this.logHandler?.info(message, ...optionalParams);
  }

  log(message?: any, ...optionalParams: any[]): void {
    this.logHandler?.log(message);
  }

  warn(message?: any, ...optionalParams: any[]): void {
    this.logHandler?.warn(message, ...optionalParams);
  }

  error(message?: any, ...optionalParams: any[]): void {
    this.logHandler?.error(message, ...optionalParams);
  }
}
